import { useParams } from 'react-router-dom'
import { getRequest } from '../../../../services/base'
import Button from '../../../common/Button'
import { useContext, useRef, useState } from 'react'
import { Close } from '@styled-icons/evil'
import CheckBox from '../../../common/CheckBox'
import { NavContext } from '../../../../context/global_context'
import { downloadErrorLogs } from '../../../../utils/common'

const ExportMissingConnectors = () => {
  const { vehicle } = useParams()
  const [state, dispatch] = useContext(NavContext)

  const unmappedSubSystemRef = useRef()
  const [showCategory, setShowCategory] = useState(false)
  const [categoryData, setCategoryData] = useState([])
  const [selectedCategory, setSelectedCategory] = useState([])

  const validateExport = async () => {
    setShowCategory(true)
    getCategoryList()
  }

  const getCategoryList = async () => {
    let res = await getRequest(`/api/connector/category/?vehicle=${vehicle}`)
    setCategoryData(res?.data)
  }

  const selectUnSelectCategory = (category) => {
    let tempCategory = [...selectedCategory]
    if (category == 'all') {
      if (tempCategory?.length === categoryData?.length) {
        setSelectedCategory([])
      } else {
        setSelectedCategory([...categoryData])
      }
    } else {
      let index = tempCategory.indexOf(category)
      if (index < 0) {
        tempCategory.push(category)
      } else {
        tempCategory.splice(index, 1)
      }
      setSelectedCategory([...tempCategory])
    }
  }

  const downloadMissingConnectors = async () => {
    if (selectedCategory?.length > 0) {
      if (
        window.confirm(`Are you sure want to download missing connectors`) ===
        true
      ) {
        dispatch({
          type: 'loader',
          data: {
            caption: 'Downloading missing connectors ....',
            showLoader: true,
          },
          notification: {},
        })

        let res = await getRequest(
          `/api/sub_system/functional-diagram/missing/connectors/?vehicle=${vehicle}&category=${selectedCategory.join(',')}`
        )
        if (res?.status) {
          downloadErrorLogs(
            res?.data,
            `functional-diagram-connectors-${vehicle}.txt`
          )
          dispatch({
            type: 'notification',
            data: {
              notification_type: 'success',
              msg: 'Successfully downloaded',
            },
          })
          setSelectedCategory([])
          setShowCategory(false)
        } else {
          dispatch({
            type: 'notification',
            data: {
              notification_type: 'error',
              msg: res?.msg,
            },
          })
        }
      }
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Please select at least one category',
        },
      })
    }
  }

  return (
    <div ref={unmappedSubSystemRef}>
      <Button
        className={`cursor-pointer btn`}
        text={`Download Missing Connectors`}
        onClick={() => {
          validateExport()
        }}
      />
      {showCategory && (
        <div style={{ position: 'relative' }}>
          <div
            className={
              'bg-tracer-darkest-blue mt-1 text-black px-2 text-black border-gray-500 border rounded'
            }
            style={{
              position: 'absolute',
              zIndex: 100,
              right: 0,
              width: '25vw',
              padding: '0 5%',
            }}
          >
            <div className="flex items-center justify-end font-bold pt-1 text-white py-2">
              <Close
                size="1.3rem"
                onClick={() => {
                  setShowCategory(false)
                }}
                className="cursor-pointer"
              />
            </div>
            <div className="text-white py-1">Select Categories to download</div>
            <div
              className={`hover:bg-blue-100 flex flex-row items-center bg-white w-full px-4 py-2 border-b border-tracer-dark-blue`}
            >
              <div>
                <CheckBox
                  name={'inputName'}
                  value={selectedCategory?.length == categoryData?.length}
                  onChange={() => {
                    selectUnSelectCategory('all')
                  }}
                  checked={selectedCategory?.length == categoryData?.length}
                />
              </div>
              <div className="w-full pl-4">
                <div className="font-bold">Select All</div>
              </div>
            </div>
            {categoryData?.map((category, categoryIndex) => {
              return (
                <div
                  className={`hover:bg-blue-100 flex flex-row items-center bg-white w-full px-4 py-2 border-b border-tracer-dark-blue`}
                  key={`category-${categoryIndex}-${category}`}
                >
                  <div>
                    <CheckBox
                      name={'inputName'}
                      value={selectedCategory?.includes(category)}
                      onChange={() => {
                        selectUnSelectCategory(category)
                      }}
                      checked={selectedCategory?.includes(category)}
                    />
                  </div>
                  <div className="w-full pl-4">
                    <div className="font-bold">{category}</div>
                  </div>
                </div>
              )
            })}
            <div className="py-3 flex justify-end">
              <Button
                className={`cursor-pointer btn`}
                text={`Download`}
                onClick={() => {
                  downloadMissingConnectors()
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ExportMissingConnectors
